
import { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Button } from '@mui/material'
import UpdateIcon from '@mui/icons-material/Update'
import DeleteIcon from '@mui/icons-material/Delete'
import CheckIcon from '@mui/icons-material/Check'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { useGridApiRef } from '@mui/x-data-grid'
import { jaJP } from '@mui/x-data-grid'
import { addDays, format } from 'date-fns'
import { usePost } from './../../apis/ApiRequests'
import { useAuth } from '../../contexts/AuthContext'
import Header from '../../components/Header'
import Frame from '../../components/uiParts/Frame'
import TitleBar from '../../components/uiParts/TitleBar'
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid'
import CloseIcon from '@mui/icons-material/Close'
import CustomSnackBar from '../../components/alert/CustomSnackBar'
import CustomConfirm from '../../components/confirm/CustomConfirm'
import CustomOutlinedInput from '../../components/input/CustomOutlinedInput'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop'
import CustomSelect from '../../components/select/CustomSelect'

const DataInputList = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth()
    const facilityCode   = authInfo.facilityCode
    const facilityName   = authInfo.facilityName
    const userId         = authInfo.userId
    const luserName      = authInfo.userName
    const authority      = authInfo.authority
    const today          = format(addDays(new Date(), 0), 'yyyy-MM-dd')
    const navigate       = useNavigate()
    
    const search    = useLocation().search
    const query     = new URLSearchParams(search)
    const reportNo  = query.get('reportNo')
    const targetDate  = query.get('targetDate')
    const checkStatus  = query.get('checkStatus') || 0

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ searchCount,          setSearchCount          ] = useState(0)
    const [ dataGridHeight,       setDataGridHeight       ] = useState(window.innerHeight - 265)
    const [ dataInputList,        setDataInputList        ] = useState([])
    const [ checkedDataInputList, setCheckedDataInputList ] = useState([])
    const [ requireMessage,       setRequireMessage       ] = useState('')
    const [ targetId,             setTargetId             ] = useState(0)
    const [ targetCell,           setTargetCell           ] = useState('senmeiCode')
    const [ shipList,             setShipList             ] = useState([])
    const [ openDialogShip,       setOpenDialogShip       ] = useState(false)
    const [ fishSpecList,         setFishSpecList         ] = useState([])
    const [ openDialogFishSpec,   setOpenDialogFishSpec   ] = useState(false)
    const [ standardList,         setStandardList         ] = useState([])
    const [ openDialogStandard,   setOpenDialogStandard   ] = useState(false)
    const [ traderList,           setTraderList           ] = useState([])
    const [ openDialogTrader,     setOpenDialogTrader     ] = useState(false)
    const [ containerList,        setContainerList        ] = useState([])
    const [ openDialogContainer,  setOpenDialogContainer  ] = useState(false)
    const [ bidPersonList,        setBidPersonList        ] = useState([])
    const [ kgKubunAll,           setKgKubunAll           ] = useState('')
    const [ tankaAll,             setTankaAll             ] = useState('')
    const [ suryoAll,             setSuryoAll             ] = useState('')
    const [ kgSuryoAll,           setKgSuryoAll           ] = useState('')
    const [ yokiSuryoAll,         setYokiSuryoAll         ] = useState('')
    const [ prevRow,              setPrevRow              ] = useState({})
    const [ focusCell,            setFocusCell            ] = useState('')
    
	//-----------------------------------------------
    // initialize - useRef
	//-----------------------------------------------
    const apiRef          = useGridApiRef()
    const kgKubunAllRef   = useRef()
    const tankaAllRef     = useRef()
    const suryoAllRef     = useRef()
    const kgSuryoAllRef   = useRef()
    const yokiSuryoAllRef = useRef()

    // BidGroupデータ
    const [ reportHeader, setReportHeader ] = useState({
        bidGroupNo      : '',
        reportNo        : '',
        entryDate       : '',
        senmeiGroupCode : '',
        senmeiGroup     : '',
        senmeiCode      : '',
        senmei          : '',
        gyoshuCode      : '',
        gyoshu          : '',
        nisugata        : '',
        kikakuCode      : '',
        kikaku          : '',
        kgKubun         : '',
        yokiCode        : '',
        yoki            : '',
        checkStatus     : '',
        correctUserCode : '',
        correctUser     : '',
        kgKubunAll      : '', 
        tankaAll        : '',
        suryoAll        : '',
        kgSuryoAll      : '',
        yokiSuryoAll    : ''
    })
    const [ registerData, setRegisterData ] = useState({
        entryDate       : '', 
        senmeiGroupCode : '',
        senmeiGroup     : '',
        senmeiCode      : '',
        senmei          : '',
        gyoshuCode      : '', 
        gyoshu          : '', 
        nisugata        : '',
        kikakuCode      : '',
        kikaku          : '',
        kgKubun         : '', 
        tanka           : '', 
        traderCode      : '', 
        trader          : '', 
        entrySuryo      : '', 
        bidSuryo        : '', 
        yokiCode        : '', 
        yoki            : '', 
        yokiSuryo       : '', 
        kingaku         : '', 
        bidGroupNo      : '', 
        traderSeq       : '', 
        checkStatus     : '', 
    })
    // UI Message
    const [ messageState, setMessageState ] = useState({
        snackBarTrue        : false,
        snackBarTrue_print  : false,
        snackBarFalse       : false,
        require             : false,
        confirm             : false,
        confirm_next        : false,
        confirm_delete_row  : false,
        confirm_register    : false,
        confirm_status_done : false,
        confirm_status_none : false
    })
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - getTransactionList / Transaction
	//-----------------------------------------------
    const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost()
    const searchData = async () => {
        const postData = {
            'className'    : 'mch.models.table.Transaction',
            'methodName'   : 'getTransactionList',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'reportNo'     : reportNo
        }
        await searchData_post(postData)
    }
	//-----------------------------------------------
    // API - setData / Transaction
	//-----------------------------------------------
    const { response : setData_res, loading : setData_Loading, post:setData_post } = usePost()
    const setData = async (registerData) => {
        const postData = {
            'className'       : 'mch.models.table.Transaction',
            'methodName'      : 'setDataByUser',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'activeFlag'      : registerData.activeFlag,
            'reportNo'        : registerData.reportNo,
            'reportSeq'       : registerData.reportSeq,
            'entryDate'       : registerData.entryDate,
            'senmeiGroupCode' : registerData.senmeiGroupCode,
            'senmeiGroup'     : registerData.senmeiGroup,
            'senmeiCode'      : registerData.senmeiCode,
            'senmei'          : registerData.senmei,
            'gyoshuCode'      : registerData.gyoshuCode,
            'gyoshu'          : registerData.gyoshu,
            'nisugata'        : registerData.nisugata,
            'kikakuCode'      : registerData.kikakuCode,
            'kikaku'          : registerData.kikaku,
            'kgKubun'         : registerData.kgKubun,
            'tanka'           : registerData.tanka,
            'traderCode'      : registerData.traderCode,
            'trader'          : registerData.trader,
            'entrySuryo'      : registerData.entrySuryo,
            'bidSuryo'        : registerData.bidSuryo,
            'yokiCode'        : registerData.yokiCode,
            'yoki'            : registerData.yoki,
            'yokiSuryo'       : registerData.yokiSuryo,
            'kingaku'         : registerData.kingaku,
            'bidGroupNo'      : registerData.bidGroupNo,
            'traderSeq'       : registerData.traderSeq,
            'checkStatus'     : registerData.checkStatus,
            'correctUserCode' : reportHeader.correctUserCode,
            'correctUser'     : reportHeader.correctUser,
        }
        await setData_post(postData)
    }
	//-----------------------------------------------
    // API - setData / Transaction
	//-----------------------------------------------
    const { response : setDataHeader_res, loading : setDataHeader_Loading, post:setDataHeader_post } = usePost()
    const setDataHeader = async (a) => {
        const postData = {
            'className'    : 'mch.models.table.Transaction',
            'methodName'   : 'setDataHeader',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'activeFlag'   : 1,
            'reportNo'     : reportHeader.reportNo,
            'kgKubunAll'   : reportHeader.kgKubunAll,
            'tankaAll'     : reportHeader.tankaAll,
            'suryoAll'     : reportHeader.suryoAll,
            'kgSuryoAll'   : reportHeader.kgSuryoAll,
            'yokiSuryoAll' : reportHeader.yokiSuryoAll
        }
        await setData_post(postData)
    }
	//-----------------------------------------------
    // API - deleteTransaction / Transaction
	//-----------------------------------------------
    const { response : generateNextReport_res, loading : generateNextReport_Loading, post:generateNextReport_post } = usePost()
    const generateNextReport = async () => {
        const postData = {
            'className'    : 'mch.models.table.Transaction',
            'methodName'   : 'generateNextReport',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : reportHeader.bidGroupNo
        }
        await generateNextReport_post(postData)
    }
	//-----------------------------------------------
    // API - updateTransaction / Transaction
	//-----------------------------------------------
    const { response : updateData_res, loading : updateData_Loading, post:updateData_post } = usePost()
    const updateData = async (checkStatus) => {
        const postData = {
            'className'    : 'mch.models.table.Transaction',
            'methodName'   : 'updateTransaction',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'reportNo'     : reportHeader.reportNo,
            'bidGroupNo'   : reportHeader.bidGroupNo,
            'checkStatus'  : checkStatus
        }
        await updateData_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Ship
	//-----------------------------------------------
    const { response : getDataAll_ship_res, post : getDataAll_ship_post } = usePost()
    const getDataAll_ship = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_ship_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Ship
	//-----------------------------------------------
    const { response : getData_ship_res, post : getData_ship_post } = usePost()
    const getData_ship = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalShip',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_ship_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.FishSpec
	//-----------------------------------------------
    const { response : getDataAll_fishSpec_res, post : getDataAll_fishSpec_post } = usePost()
    const getDataAll_fishSpec = async () => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_fishSpec_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.FishSpec
	//-----------------------------------------------
    const { response : getData_fishSpec_res, post : getData_fishSpec_post } = usePost()
    const getData_fishSpec = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishSpec_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Standard
	//-----------------------------------------------
    const { response : getDataAll_standard_res, post : getDataAll_standard_post } = usePost()
    const getDataAll_standard = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_standard_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Standard
	//-----------------------------------------------
    const { response : getData_standard_res, post : getData_standard_post } = usePost()
    const getData_standard = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_standard_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Trader
	//-----------------------------------------------
    const { response : getDataAll_trader_res, post : getDataAll_trader_post } = usePost()
    const getDataAll_trader = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Trader',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_trader_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Trader
	//-----------------------------------------------
    const { response : getData_trader_res, post : getData_trader_post } = usePost()
    const getData_trader = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Trader',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_trader_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Container
	//-----------------------------------------------
    const { response : getDataAll_container_res, post : getDataAll_container_post } = usePost()
    const getDataAll_container = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Container',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_container_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Container
	//-----------------------------------------------
    const { response : getData_container_res, post : getData_container_post } = usePost()
    const getData_container = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Container',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_container_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.BidPerson
	//-----------------------------------------------
    const { response : getDataAll_bidPerson_res, post : getDataAll_bidPerson_post } = usePost()
    const getDataAll_bidPerson = async () => {
        const postData = {
            'className'    : 'mch.models.masta.BidPerson',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_bidPerson_post(postData)
    }
	//-----------------------------------------------
    // API - getData / masta.BidPerson
	//-----------------------------------------------
    const { response : getData_bidPerson_res, post : getData_bidPerson_post } = usePost()
    const getData_bidPerson = async (bidPersonCode) => {
        const postData = {
            'className'    : 'mch.models.masta.BidPerson',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : bidPersonCode
        }
        await getData_bidPerson_post(postData)
    }
    //-----------------------------------------------
    // API - setDataBySalesReport / request_Print
    //-----------------------------------------------
    const { response : setData_salesReport_res, post : setData_salesReport_post } = usePost()
    const setData_salesReport = async () => {
        const postData = {
            'className'    : 'mch.models.request.Print',
            'methodName'   : 'setDataBySalesReport',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'targetDate'   : reportHeader.entryDate,
            'authority'    : authority,
            'targetGroup'  : reportHeader.bidGroupNo
        }
        await setData_salesReport_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1)
        
        setFocusCell('kgKubunAllRef')
        kgKubunAllRef.current.focus()
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 210)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
        
    },[])
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData()
        getDataAll_ship()
        getDataAll_fishSpec()
        getDataAll_standard()
        getDataAll_trader()
        getDataAll_container()
        getDataAll_bidPerson()
    }, [searchCount])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchDataByDataInput / bidGroup)
	//-----------------------------------------------
    useEffect(() => {
        setDataInputList([])
        if (searchData_res) {
            setDataInputList(searchData_res.Data)
            setReportHeader(prevSearchData => ({
                ...prevSearchData,
                reportNo        : searchData_res.reportNo,
                entryDate       : searchData_res.entryDate,
                senmeiGroupCode : searchData_res.senmeiGroupCode,
                senmeiGroup     : searchData_res.senmeiGroup,
                senmeiCode      : searchData_res.senmeiCode,
                senmei          : searchData_res.senmei,
                gyoshuCode      : searchData_res.gyoshuCode,
                gyoshu          : searchData_res.gyoshu,
                nisugata        : searchData_res.nisugata,
                kikakuCode      : searchData_res.kikakuCode,
                kikaku          : searchData_res.kikaku,
                kgKubun         : searchData_res.kgKubun,
                yokiCode        : searchData_res.yokiCode,
                yoki            : searchData_res.yoki,
                checkStatus     : searchData_res.checkStatus,
                bidGroupNo      : searchData_res.bidGroupNo,
                correctUserCode : searchData_res.correctUserCode,
                correctUser     : searchData_res.correctUser,
                kgKubunAll      : searchData_res.kgKubunAll,
                tankaAll        : searchData_res.tankaAll,
                suryoAll        : searchData_res.suryoAll,
                kgSuryoAll      : searchData_res.kgSuryoAll,
                yokiSuryoAll    : searchData_res.yokiSuryoAll,
            }))
            if (!searchData_res.existFlag) {
                //navigate('/dataInput')
                navigate(`/dataInput?targetDate=${ targetDate }&checkStatus=${ checkStatus }`)
            }
        }
    }, [searchData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            setMessageInfo('confirm_next', false)
            setMessageInfo('confirm_delete_row', false)
            setMessageInfo('confirm_register', false)
            setMessageInfo('snackBarTrue', true)
            
            setSearchCount(searchCount+1)
        }
    }, [setData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(updateData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (updateData_res) {
            setMessageInfo('confirm_status_done', false)
            setMessageInfo('confirm_status_none', false)
            setMessageInfo('snackBarTrue', true)
            
            setSearchCount(searchCount+1)
        }
    }, [updateData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(deleteTransaction / Transaction)
	//-----------------------------------------------
    useEffect(() => {
        if (generateNextReport_res) {
            //navigate('/dataInput')
            navigate(`/dataInput?targetDate=${ targetDate }&checkStatus=${ checkStatus }`)
        }
    }, [generateNextReport_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setShipList([])
        if (getDataAll_ship_res) {
            setShipList(getDataAll_ship_res.Data)
        }
    }, [getDataAll_ship_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_ship_res) {
            if (targetId === 1) {
                setDataInputList((prevData) => {
                    return prevData.map((row) => {
                        if (getData_ship_res.displayName) {
                            row.senmeiCode  = getData_ship_res.code
                            row.senmei      = getData_ship_res.displayName
                            return row
                        } else {
                            setRequireMessage('マスタに登録がありません')
                            setMessageInfo('require', true)
                            row.senmeiCode  = prevRow.senmeiCode
                            row.senmei      = prevRow.senmei
                            return row

                        }
                    })
                })
            } else {
                setDataInputList((prevData) => {
                    return prevData.map((row) => {
                        if (row.id === targetId) {
                            if (getData_ship_res.displayName) {
                                row.senmeiCode  = getData_ship_res.code
                                row.senmei      = getData_ship_res.displayName
                            } else {
                                setRequireMessage('マスタに登録がありません')
                                setMessageInfo('require', true)
                                row.senmeiCode  = prevRow.senmeiCode
                                row.senmei      = prevRow.senmei
                            }
                            return row
                        }
                        return row
                    })
                })
            }
        }
    }, [getData_ship_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        setFishSpecList([])
        if (getDataAll_fishSpec_res) {
            setFishSpecList(getDataAll_fishSpec_res.Data)
        }
    }, [getDataAll_fishSpec_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishSpec_res) {
            if (targetId === 1) {
                setDataInputList((prevData) => {
                    return prevData.map((row) => {
                        if (getData_fishSpec_res.displayName) {
                            row.gyoshuCode  = getData_fishSpec_res.code
                            row.gyoshu      = getData_fishSpec_res.displayName
                            return row
                        } else {
                            setRequireMessage('マスタに登録がありません')
                            setMessageInfo('require', true)
                            row.gyoshuCode  = prevRow.gyoshuCode
                            row.gyoshu      = prevRow.gyoshu
                            return row

                        }
                    })
                })
            } else {
                setDataInputList((prevData) => {
                    return prevData.map((row) => {
                        if (row.id === targetId) {
                            if (getData_fishSpec_res.displayName) {
                                row.gyoshuCode  = getData_fishSpec_res.code
                                row.gyoshu      = getData_fishSpec_res.displayName
                            } else {
                                setRequireMessage('マスタに登録がありません')
                                setMessageInfo('require', true)
                                row.gyoshuCode  = prevRow.gyoshuCode
                                row.gyoshu      = prevRow.gyoshu
                            }
                            return row
                        }
                        return row
                    })
                })
            }
        }
    }, [getData_fishSpec_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_Standard)
	//-----------------------------------------------
    useEffect(() => {
        setStandardList([])
        if (getDataAll_standard_res) {
            setStandardList(getDataAll_standard_res.Data)
        }
    }, [getDataAll_standard_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_standard)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_standard_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_standard_res.displayName) {
                            row.kikakuCode  = getData_standard_res.code
                            row.kikaku      = getData_standard_res.displayName
                        } else {
                            setRequireMessage('マスタに登録がありません')
                            setMessageInfo('require', true)
                            row.kikakuCode  = prevRow.kikakuCode
                            row.kikaku      = prevRow.kikaku
                        }
                        return row
                    }
                    return row
                })
            })
        }
    }, [getData_standard_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_Trader)
	//-----------------------------------------------
    useEffect(() => {
        setTraderList([])
        if (getDataAll_trader_res) {
            setTraderList(getDataAll_trader_res.Data)
        }
    }, [getDataAll_trader_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_trader)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_trader_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_trader_res.displayName) {
                            row.traderCode  = getData_trader_res.code
                            row.trader      = getData_trader_res.displayName
                        } else {
                            setRequireMessage('マスタに登録がありません')
                            setMessageInfo('require', true)
                            row.traderCode  = prevRow.traderCode
                            row.trader      = prevRow.trader
                        }
                        return row
                    }
                    return row
                })
            })
        }
    }, [getData_trader_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_Container)
	//-----------------------------------------------
    useEffect(() => {
        setContainerList([])
        if (getDataAll_container_res) {
            setContainerList(getDataAll_container_res.Data)
        }
    }, [getDataAll_container_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_container)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_container_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_container_res.displayName) {
                            row.yokiCode  = getData_container_res.code
                            row.yoki      = getData_container_res.displayName
                        } else {
                            setRequireMessage('マスタに登録がありません')
                            setMessageInfo('require', true)
                            row.yokiCode  = prevRow.yokiCode
                            row.yoki      = prevRow.yoki
                        }
                        return row
                    }
                    return row
                })
            })
        }
    }, [getData_container_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_BidPerson)
	//-----------------------------------------------
    useEffect(() => {
        setBidPersonList([])
        if (getDataAll_bidPerson_res) {
            setBidPersonList(getDataAll_bidPerson_res.Data)
        }
    }, [getDataAll_bidPerson_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_BidPerson)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_bidPerson_res) {
            setReportHeader(prevSearchData => ({
                ...prevSearchData,
                correctUserCode: getData_bidPerson_res.code,
                correctUser: getData_bidPerson_res.displayName,
            }))
        }
    }, [getData_bidPerson_res])
	//-----------------------------------------------
    // useEffect - setDataBySalesReport / request_Print
	//-----------------------------------------------
    useEffect(() => {
        if (setData_salesReport_res) {
            setMessageInfo('snackBarTrue_print', true)
        }
    }, [setData_salesReport_res])

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - ブランク行を追加
	//-----------------------------------------------
    const handleClick_addRow = () => {
        if (dataInputList.length > 9) {
            setRequireMessage('データの入力は10行までです。追加する場合は「ページ追加」ボタンで新しい浜帳ページを追加してください')
            setMessageInfo('require', true)
        } else {
            let newId = dataInputList.length > 0 ? Math.max(...dataInputList.map(r => r.id)) + 1 : 1
            const newRows = generateNewRows(newId, 1)
            setDataInputList([...dataInputList, ...newRows])
        }
    }
	//-----------------------------------------------
    // eventHandler - ブランク行を追加
	//-----------------------------------------------
    const generateNewRows = (startId, count) => {
        const rows = [];
        for (let i = 0; i < count; i++) {
            rows.push({
                id: startId + i,
                reportNo        : reportHeader.reportNo, 
                reportSeq       : startId + i, 
                entryDate       : reportHeader.entryDate, 
                senmeiGroupCode : reportHeader.senmeiGroupCode,
                senmeiGroup     : reportHeader.senmeiGroup,
                senmeiCode      : reportHeader.senmeiCode,
                senmei          : reportHeader.senmei,
                gyoshuCode      : reportHeader.gyoshuCode, 
                gyoshu          : reportHeader.gyoshu, 
                nisugata        : reportHeader.nisugata,
                kikakuCode      : reportHeader.kikakuCode,
                kikaku          : reportHeader.kikaku,
                kgKubun         : reportHeader.kgKubun, 
                tanka           : '', 
                traderCode      : '', 
                trader          : '', 
                entrySuryo      : 1, 
                bidSuryo        : '', 
                yokiCode        : reportHeader.yokiCode, 
                yoki            : reportHeader.yoki, 
                yokiSuryo       : 1, 
                kingaku         : 0, 
                checkStatus     : 0,
                bidGroupNo      : reportHeader.bidGroupNo, 
                correctUserCode : reportHeader.correctUserCode, 
                correctUser     : reportHeader.correctUser, 
            })
        }
        return rows;
    }
	//-----------------------------------------------
    // eventHandler - ブランク行を追加
	//-----------------------------------------------
    const handleClick_print = () => {
        setData_salesReport()
        setMessageInfo('snackBarTrue_print', true)
    }
	//-----------------------------------------------
    // eventHandler - 入力情報の変更
	//-----------------------------------------------
    const handleChange = (name, value) => {
        setReportHeader(prevSearchData => ({
            ...prevSearchData,
            [name]: value,
        }))}
    
	//-----------------------------------------------
    // eventHandler - セリ人の変更
	//-----------------------------------------------
    const handleChangexBidPerson = (value) => {
        if (value == 0) {
            setReportHeader(prevSearchData => ({
                ...prevSearchData,
                correctUserCode: '',
                correctUser: '',
            }))
        } else {
            getData_bidPerson(value)
        }
    }
    const calcTotalNum = () => {
        // Kg区分の合計値
        const totalKgKubun = dataInputList?.reduce((acc, item) => {
            // kgKubunが数値かチェック
            const kgKubunValue = Number(item.kgKubun);
            return !isNaN(kgKubunValue) ? acc + kgKubunValue : acc;
        }, 0);
        setKgKubunAll(totalKgKubun)
        
        // 単価の合計値
        const totalTanka = dataInputList?.reduce((acc, item) => {
            // kgKubunが数値かチェック
            const tankaValue = Number(item.tanka);
            return !isNaN(tankaValue) ? acc + tankaValue : acc;
        }, 0);
        setTankaAll(totalTanka)
        
        // 数量の合計値
        const totalSuryo = dataInputList?.reduce((acc, item) => {
            // kgKubunが数値かチェック
            const suryoValue = Number(item.entrySuryo);
            return !isNaN(suryoValue) ? acc + suryoValue : acc;
        }, 0);
        setSuryoAll(totalSuryo)
        
        // Kg数量の合計値
        const totalKgSuryo = dataInputList?.reduce((acc, item) => {
            // kgKubunが数値かチェック
            const kgSuryoValue = Number(item.bidSuryo);
            return !isNaN(kgSuryoValue) ? acc + kgSuryoValue : acc;
        }, 0);
        setKgSuryoAll(totalKgSuryo)
        
        // 容器数量の合計値
        const totalYokiSuryo = dataInputList?.reduce((acc, item) => {
            // kgKubunが数値かチェック
            const yokiSuryoValue = Number(item.yokiSuryo);
            return !isNaN(yokiSuryoValue) ? acc + yokiSuryoValue : acc;
        }, 0);
        setYokiSuryoAll(totalYokiSuryo)
    }
	//===============================================
	// マスタヘルプ
	//===============================================
	//-----------------------------------------------
    // マスタヘルプ - 船名ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_ship_close = () => {
        setOpenDialogShip(false)
    }
    //-----------------------------------------------
    // マスタヘルプ - 船名マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_ship = (code, displayName) => {
        if (targetId === 1) {
            setDataInputList((prevData) => {
                  return prevData.map((row) => {
                      if (code) {
                          row.senmeiCode = code
                          row.senmei     = displayName
                          return row
                      }
                  return row
                })
            })
        } else {
            setDataInputList((prevData) => {
                  return prevData.map((row) => {
                      if (row.id === targetId) {
                          row.senmeiCode = code
                          row.senmei     = displayName
                          return row
                      }
                  return row
                })
            })
        }
        handleClick_dialog_ship_close()
    }
	//-----------------------------------------------
    // マスタヘルプ - 魚種ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpec_close = () => {
        setOpenDialogFishSpec(false)
    }
    //-----------------------------------------------
    // マスタヘルプ - 魚種マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishSpec = (code, displayName) => {
        setDataInputList((prevData) => {
              return prevData.map((row) => {
                  if (row.id === targetId) {
                      row.gyoshuCode = code
                      row.gyoshu     = displayName
                      return row
                  }
              return row
            })
        })
        handleClick_dialog_fishSpec_close()
    }
	//-----------------------------------------------
    // マスタヘルプ - 規格ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_standard_close = () => {
        setOpenDialogStandard(false)
    }
    //-----------------------------------------------
    // マスタヘルプ - 規格マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_standard = (code, displayName) => {
        setDataInputList((prevData) => {
              return prevData.map((row) => {
                  if (row.id === targetId) {
                      row.kikakuCode = code
                      row.kikaku     = displayName
                      return row
                  }
              return row
            })
        })
        handleClick_dialog_standard_close()
    }
	//-----------------------------------------------
    // マスタヘルプ - 仲買人ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_trader_close = () => {
        setOpenDialogTrader(false)
    }
    //-----------------------------------------------
    // マスタヘルプ - 仲買人マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_trader = (code, displayName) => {
        setDataInputList((prevData) => {
              return prevData.map((row) => {
                  if (row.id === targetId) {
                      row.traderCode = code
                      row.trader     = displayName
                      return row
                  }
              return row
            })
        })
        handleClick_dialog_trader_close()
    }
	//-----------------------------------------------
    // マスタヘルプ - 容器ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_container_close = () => {
        setOpenDialogContainer(false)
    }
    //-----------------------------------------------
    // マスタヘルプ - 容器マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_container = (code, displayName) => {
        setDataInputList((prevData) => {
              return prevData.map((row) => {
                  if (row.id === targetId) {
                      row.yokiCode = code
                      row.yoki     = displayName
                      return row
                  }
              return row
            })
        })
        handleClick_dialog_container_close()
    }
	//===============================================
	// dataGrid
	//===============================================
	//-----------------------------------------------
    // dataGrid - テーブルの見出し
	//-----------------------------------------------
    const columns = [
        { field: 'reportSeq',  headerName: 'No',    width: 40, columnSeparatorWidth: 1, sortable:false, editable:false, type:'number', },
        { field: 'senmeiCode',     headerName: 'コード',      width: 70, columnSeparatorWidth: 1, sortable:false, editable:true, 
            renderCell: (params) => (
            <div
                style={{
                color: /^\d{3}$/.test(params.row.senmeiCode) ? 'red' : 'inherit', 
                }}
            >
                {params.value}
            </div>
            ),
        },
        { field: 'senmei',     headerName: '荷主',      width: 120, columnSeparatorWidth: 1, sortable:false, editable:true, 
            renderCell: (params) => (
            <div
                style={{
                color: /^\d{3}$/.test(params.row.senmeiCode) ? 'red' : 'inherit', 
                }}
            >
                {params.value}
            </div>
            ),
        },
        { field: 'gyoshuCode', headerName: 'コード', width: 70, columnSeparatorWidth: 1, sortable:false, editable:true,  },
        { field: 'gyoshu',     headerName: '魚種',   width: 100, columnSeparatorWidth: 1, sortable:false, editable:true,  },
        { field: 'kikakuCode', headerName: 'コード', width: 70, columnSeparatorWidth: 1, sortable:false, editable:true,  },
        { field: 'kikaku',     headerName: '規格',   width: 150, columnSeparatorWidth: 1, sortable:false, editable:true,  },
        { field: 'nisugata',   headerName: '荷姿',   width: 60, columnSeparatorWidth: 1, sortable:false, editable:true,  },
        { field: 'kgKubun',    headerName: 'Kg区',   width: 60, columnSeparatorWidth: 1, sortable:false, editable:true,  },
        { field: 'tanka',      headerName: '単価',   width: 90, columnSeparatorWidth: 1, sortable:false, editable:false, type:'number', },
        { field: 'traderCode', headerName: 'コード', width: 70, columnSeparatorWidth: 1, sortable:false, editable:false,  },
        { field: 'trader',     headerName: '買受人', width: 100, columnSeparatorWidth: 1, sortable:false, editable:false,  },
        { field: 'entrySuryo', headerName: '数量',   width: 80, columnSeparatorWidth: 1, sortable:false, editable:true, type:'number',  },
        { field: 'bidSuryo',   headerName: 'K数',    width: 90, columnSeparatorWidth: 1, sortable:false, editable:true, type:'number', },
        { field: 'yokiCode',   headerName: 'コード', width: 60, columnSeparatorWidth: 1, sortable:false, editable:true,  },
        { field: 'yoki',       headerName: '容器名', width: 80, columnSeparatorWidth: 1, sortable:false, editable:true,  },
        { field: 'yokiSuryo',  headerName: '容器数', width: 70, columnSeparatorWidth: 1, sortable:false, editable:true, type:'number', },
        //{ field: 'kingaku',    headerName: '金額',   width: 100, columnSeparatorWidth: 1, sortable:false, editable:false, type:'number', },
    ]
	//-----------------------------------------------
    // dataGrid - フォーカス制御
	//-----------------------------------------------
    useEffect(() => {
        // データが読み込まれていることを確認
        if (dataInputList.length > 0) {
            
            // 一番下の行を編集した場合はブランク行を追加
            const lastRowId = dataInputList[dataInputList.length - 1].id
            if (lastRowId == targetId) {
                //handleClick_addRow()
            }
            // フォーカスを右側のセルに移動する
            let i = targetId
            let j = 'senmeiCode'
            if (targetId) {
                if (targetCell == 'senmeiCode') j = 'gyoshuCode'
                if (targetCell == 'gyoshuCode') j = 'kikakuCode'
                if (targetCell == 'kikakuCode') j = 'nisugata'
                if (targetCell == 'senmei') j = 'gyoshu'
                if (targetCell == 'gyoshu') j = 'kikaku'
                if (targetCell == 'kikaku') j = 'nisugata'
                if (targetCell == 'nisugata') j = 'kgKubun'
                if (targetCell == 'kgKubun') j = 'tanka'
                if (targetCell == 'tanka') j = 'traderCode'
                if (targetCell == 'traderCode') j = 'entrySuryo'
                if (targetCell == 'trader') j = 'entrySuryo'
                if (targetCell == 'entrySuryo') j = 'bidSuryo'
                if (targetCell == 'bidSuryo') j = 'yokiCode'
                if (targetCell == 'yokiCode') j = 'yokiSuryo'
                if (targetCell == 'yokiSuryo') {
                    ++i
                    j = 'senmeiCode'
                    setTargetId(j)
                }
                //apiRef.current.setCellFocus(i, j)
            }
            calcTotalNum()
        }
    }, [dataInputList])
    //-----------------------------------------------
    // dataGrid - 行の選択
    //-----------------------------------------------
    const handleClick_dataInputList = (event) => {
        if (event.field === '__check__') {
            if (checkedDataInputList.includes(event.id)) {
                setCheckedDataInputList(checkedDataInputList.filter((checkedDataInputList, index) => (checkedDataInputList !== event.id)))
            } else {
                setCheckedDataInputList((checkedDataInputList)=>[...checkedDataInputList, event.id])
            }
        }
        // 対象のセルはマスタヘルプを表示
        if (event.field == 'senmei') setOpenDialogShip(true)
        //if (event.field == 'gyoshu') setOpenDialogFishSpec(true)
        if (event.field == 'kikaku') setOpenDialogStandard(true)
        if (event.field == 'trader') setOpenDialogTrader(true)
        if (event.field == 'yoki') setOpenDialogContainer(true)
        
        // 現在のフォーカスをセット
        setTargetId(event.id)
        setTargetCell(event.field)

        dataInputList.map((row) => {
            if (row.id === event.id) {
                setPrevRow(row)
            }
        })
    }
    //-----------------------------------------------
    // dataGrid - 行の更新処理
    //-----------------------------------------------
    const handleProcessRowUpdate = (newRow, oldRow) => {
        let targetId = newRow.id
        setPrevRow(oldRow)
        setDataInputList((prevData) => {
            return prevData.map((row) => {
                if (row.id === targetId) {
                    if (targetCell == 'senmeiCode') getData_ship(newRow.senmeiCode)
                    if (targetCell == 'kikakuCode') getData_standard(newRow.kikakuCode)
                    if (targetCell == 'traderCode') getData_trader(newRow.traderCode)
                    if (targetCell == 'yokiCode') getData_container(newRow.yokiCode)
                    if (targetCell == 'gyoshuCode') getData_fishSpec(newRow.gyoshuCode)
                    
                    let kingaku = Math.round(newRow.tanka * newRow.entrySuryo)
                    if (newRow.bidSuryo) {
                        kingaku = Math.round(kingaku * newRow.bidSuryo)
                    }
                    newRow.kingaku = kingaku

                    return newRow
                }
            return row
            })
        })
        return newRow
    }
    //-----------------------------------------------
    // dataGrid - テンキーのクリック
    //-----------------------------------------------
    const handleCellKeyDown = (event, params) => {
        setTargetId(event.id)
        setTargetCell(event.field)
    }
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
    // Function - 合計欄のフォーカス制御
	//-----------------------------------------------
    const handleKeyDown = (event, index) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // フォーム送信を防止
            if (index == 'kgKubunAll') {
                setFocusCell('tankaAllRef')
                tankaAllRef.current.focus()
            }
            if (index == 'tankaAll') {
                setFocusCell('suryoAllRef')
                suryoAllRef.current.focus()
            }
            if (index == 'suryoAll') {
                setFocusCell('kgSuryoAllRef')
                kgSuryoAllRef.current.focus()
            }
            if (index == 'kgSuryoAll') {
                setFocusCell('yokiSuryoAllRef')
                yokiSuryoAllRef.current.focus()
            }
            if (index == 'yokiSuryoAll') {
                setFocusCell('kgKubunAllRef')
                kgKubunAllRef.current.focus()
            }
        }
    }
	//-----------------------------------------------
    // Function - 登録処理
	//-----------------------------------------------
    const register = () => {
        dataInputList.map((targetData) => {
            targetData.activeFlag  = 1
            const requireStatus = checkedRequire() // 必須項目をチェックする
            if (requireStatus) {
                setData(targetData)
            } else {
                setMessageInfo('require', true)
            }
        })
        setDataHeader()
        return false
    }
	//-----------------------------------------------
    // Function - チェック完了処理
	//-----------------------------------------------
    const registerCheck = () => {
        dataInputList.map((targetData) => {
            const requireStatus = checkedRequire() // 必須項目をチェックする
            if (requireStatus) {
                updateData(1)
                //register()
            } else {
                setMessageInfo('require', true)
            }
        })
        return false
    }
	//-----------------------------------------------
    // Function - 選択行の削除
	//-----------------------------------------------
    const delete_row = async () => {
        checkedDataInputList.map((item) => {
            dataInputList.map((targetData) => {
                if (item == targetData.id) {
                    targetData.activeFlag  = 0
                    setData(targetData)
                }
            })
        })
        return false
    }
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = [];
    
        if (!reportHeader.correctUserCode) errorFields.push('「補正入力者」')
        if (errorFields.length) {
            const text = errorFields.join('、') + 'が入力されていません'
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        if (reportHeader.kgKubunAll != kgKubunAll) errorFields.push('「Kg区分」')
        if (reportHeader.tankaAll != tankaAll) errorFields.push('「単価」')
        if (reportHeader.suryoAll != suryoAll) errorFields.push('「数量」')
        if (reportHeader.kgSuryoAll != kgSuryoAll) errorFields.push('「K数」')
        if (reportHeader.yokiSuryoAll != yokiSuryoAll) errorFields.push('「容器数」')
        if (errorFields.length) {
            const text = errorFields.join('、') + 'の合計が一致ません'
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        const hasThreeDigitSenmeiCode = dataInputList.some(item => {
            return item.senmeiCode && item.senmeiCode.toString().length === 3;
        })  
        if (hasThreeDigitSenmeiCode) {
            setRequireMessage('荷主コードが確定していない行があります');
            return false;  // エラーがある場合は false を返します
        }
        
        return true  // エラーがない場合は true を返します
    }
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }))
    }
    //===============================================
    // Css
    //===============================================
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'690px', color:'#fff', backgroundColor:'#808080'
    }
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage={`/dataInput?targetDate=${ targetDate }&checkStatus=${ checkStatus }`} />
            <div className='dataInput bodyContens'>
                <TitleBar title="データ補正" />
                <div className='mainContents'>
                    <Frame classname="frame" title="浜帳明細">
                        <div style={{display:'flex'}}>
                            {
                                reportHeader.checkStatus ?
                                <div style={{height: '40px', padding:'7px', fontWeight:'bold', backgroundColor:'#006400', color:'#fff', width:'120px'}}><span>チェック完了</span></div>
                                :
                                <div style={{height: '40px', padding:'7px', fontWeight:'bold', backgroundColor:'red', color:'#fff', width:'120px'}}><span>未チェック</span></div>
                            }
                            <div style={{marginLeft:'10px'}}>
                                <CustomOutlinedInput
                                    type  = "text"
                                    id    = "bidManager_bidGroupNo"
                                    label = "浜帳No"
                                    value = { reportHeader.reportNo }
                                    width = "100px"
                                />
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <Button
                                    color     = "secondary"
                                    style     = {{color:'#fff'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<AddCircleIcon />}
                                    onClick   = {() => handleClick_addRow() }
                                >
                                行追加
                                </Button>
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <Button
                                    color     = "secondary"
                                    style     = {{color:'#fff', backgroundColor: 'grey'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<DeleteIcon />}
                                    onClick   = {() => setMessageInfo('confirm_delete_row', true) }
                                >
                                行削除
                                </Button>
                            </div>
                            <div style={{marginLeft:'10px', marginBottom:'8px'}}>
                                <Button
                                    color     = "primary"
                                    style     = {{color:'#fff'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<AddCircleIcon />}
                                    onClick   = {() => setMessageInfo('confirm_next', true) }
                                >
                                ページ追加
                                </Button>
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <Button
                                    color     = "secondary"
                                    style     = {{color:'#fff'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<LocalPrintshopIcon />}
                                    onClick   = { () => handleClick_print() }
                                >
                                印刷
                                </Button>
                            </div>
                            <div style={{marginLeft:'40px'}}>
                                <Button
                                    color     = "primary"
                                    style     = {{color:'#fff'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<UpdateIcon />}
                                    onClick   = { () => setMessageInfo('confirm_register', true) }
                                >
                                保存
                                </Button>
                            </div>
                            {
                                reportHeader.checkStatus ?
                                <div style={{marginLeft:'10px', marginBottom:'8px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff', backgroundColor: 'red'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<CheckIcon />}
                                        onClick   = { () => setMessageInfo('confirm_status_none', true) }
                                    >
                                    未チェックに戻す
                                    </Button>
                                </div>
                                :
                                <div style={{marginLeft:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<CheckIcon />}
                                        onClick   = { () => setMessageInfo('confirm_status_done', true) }
                                    >
                                    チェック完了
                                    </Button>
                                </div>
                            }
                            <div style={{marginBottom:'8px', marginLeft:'10px'}}>
                                <CustomSelect
                                    id         = "userList_traderCode"
                                    label      = "補正入力者"
                                    width      = "100px"
                                    dataList   = {bidPersonList} 
                                    selectedId = {reportHeader.correctUserCode} 
                                    onChange   = {(e) => handleChangexBidPerson(e.target.value)} 
                                />
                            </div>
                        </div>
                        <div style={{marginTop:'10px'}}>
                            <CustomDataGrid
                                apiRef          = { apiRef }
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                }
                                editMode                = "row"
                                disableSelectionOnClick = { true } 
                                rows                    = { dataInputList }
                                columns                 = { columns }
                                sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                density                 = "compact"
                                localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                showColumnRightBorder
                                showCellRightBorder
                                checkboxSelection
                                disableRowSelectionOnClick = {true}
                                disableColumnMenu          = {true}
                                hideFooter
                                onCellClick                = {(event) => handleClick_dataInputList(event)}
                                processRowUpdate           = {handleProcessRowUpdate}
                                onRowSelectionModelChange  = {(newSelectionModel) => { setCheckedDataInputList(newSelectionModel) }}
                                rowSelectionModel          = {checkedDataInputList}
                                loading                    = { searchData_Loading }
                                onCellKeyDown              = {handleCellKeyDown}

                            />
                        </div>
                        <div style={{display:'flex', marginTop:'10px', justifyContent: 'flex-end'}}>
                            <div style={{padding:'8px', fontWeight:'bold'}}>
                                <span>合計：</span>
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <CustomOutlinedInput
                                    inputRef = {kgKubunAllRef}
                                    type  = "number"
                                    id    = "bidManager_kgKubunAll"
                                    label = "Kg区"
                                    value = { reportHeader.kgKubunAll }
                                    width = "110px"
                                    onChange = {(e) => handleChange('kgKubunAll', e.target.value)}
                                    onKeyDown={(event) => handleKeyDown(event, 'kgKubunAll')}
                                />
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <CustomOutlinedInput
                                    inputRef = {tankaAllRef}
                                    type  = "number"
                                    id    = "bidManager_tankaAll"
                                    label = "単価"
                                    value = { reportHeader.tankaAll }
                                    width = "110px"
                                    onChange = {(e) => handleChange('tankaAll', e.target.value)}
                                    onKeyDown={(event) => handleKeyDown(event, 'tankaAll')}
                                />
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <CustomOutlinedInput
                                    inputRef = {suryoAllRef}
                                    type  = "number"
                                    id    = "bidManager_suryoAll"
                                    label = "数量"
                                    value = { reportHeader.suryoAll }
                                    width = "110px"
                                    onChange = {(e) => handleChange('suryoAll', e.target.value)}
                                    onKeyDown={(event) => handleKeyDown(event, 'suryoAll')}
                                />
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <CustomOutlinedInput
                                    inputRef = {kgSuryoAllRef}
                                    type  = "number"
                                    id    = "bidManager_kgSuryoAll"
                                    label = "K数"
                                    value = { reportHeader.kgSuryoAll }
                                    width = "110px"
                                    onChange = {(e) => handleChange('kgSuryoAll', e.target.value)}
                                    onKeyDown={(event) => handleKeyDown(event, 'kgSuryoAll')}
                                />
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <CustomOutlinedInput
                                    inputRef = {yokiSuryoAllRef}
                                    type  = "number"
                                    id    = "bidmanager_yokiSuryoAll"
                                    label = "容器数量"
                                    value = { reportHeader.yokiSuryoAll }
                                    width = "110px"
                                    onChange = {(e) => handleChange('yokiSuryoAll', e.target.value)}
                                    onKeyDown={(event) => handleKeyDown(event, 'yokiSuryoAll')}
                                />
                            </div>
                        </div>
                    </Frame>
                </div>
                <div className='dialog_shipList'>
                    <Dialog open={ openDialogShip } onClose={ handleClick_dialog_ship_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷主を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'990px', height:'650px'}}>
                            {shipList.map((item, index) => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'210px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_ship(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_ship_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishSpecList'>
                    <Dialog open={ openDialogFishSpec } onClose={ handleClick_dialog_fishSpec_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="魚種を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {fishSpecList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_fishSpec(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishSpec_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_kikakuList'>
                    <Dialog open={ openDialogStandard } onClose={ handleClick_dialog_standard_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="規格マスタ検索" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {standardList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_standard(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_standard_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_traderList'>
                    <Dialog open={ openDialogTrader } onClose={ handleClick_dialog_trader_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="仲買人マスタ検索" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {traderList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_trader(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_trader_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_containerList'>
                    <Dialog open={ openDialogContainer } onClose={ handleClick_dialog_container_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="容器マスタ検索" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {containerList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_container(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'90%', marginRight:'5%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_container_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarTrue_print}
                    onClose         = {() => setMessageInfo('snackBarTrue_print', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "印刷指示を送信しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarFalse}
                    onClose         = {() => setMessageInfo('snackBarFalse', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_next}
                    onClose   = {() => setMessageInfo('confirm_next', false)}
                    onClickNG = {() => setMessageInfo('confirm_next', false)}
                    onClickOK = {() => generateNextReport()}
                    message   = {'新しい浜帳Noでこの入札のページを追加します。よろしいですか？'}
                />
                <CustomConfirm
                    open      = {messageState.confirm_delete_row}
                    onClose   = {() => setMessageInfo('confirm_delete_row', false)}
                    onClickNG = {() => setMessageInfo('confirm_delete_row', false)}
                    onClickOK = {() => delete_row(0)}
                    message   = {'選択行を削除します。よろしいですか？'}
                />
                <CustomConfirm
                    open      = {messageState.confirm_register}
                    onClose   = {() => setMessageInfo('confirm_register', false)}
                    onClickNG = {() => setMessageInfo('confirm_register', false)}
                    onClickOK = {() => register()}
                    message   = {'入力データを保存します。よろしいですか？'}
                />
                <CustomConfirm
                    open      = {messageState.confirm_status_done}
                    onClose   = {() => setMessageInfo('confirm_status_done', false)}
                    onClickNG = {() => setMessageInfo('confirm_status_done', false)}
                    onClickOK = {() => registerCheck()}
                    message   = {'ステータスをチェック完了にします。よろしいですか？'}
                />
                <CustomConfirm
                    open      = {messageState.confirm_status_none}
                    onClose   = {() => setMessageInfo('confirm_status_none', false)}
                    onClickNG = {() => setMessageInfo('confirm_status_none', false)}
                    onClickOK = {() => updateData(0)}
                    message   = {'ステータスをチェック未完了にします。よろしいですか？'}
                />
        </>
    )
}
export default DataInputList
